import BrandWordmark from './BrandWordmark'

/** Centered logo + wordmark on listing card photos (catalog, favorites, featured). */
export default function ListingPhotoBrandOverlay() {
  return (
    <div className="listing-photo-brand-overlay" aria-hidden="true">
      <BrandWordmark watermark className="brand-wordmark--listing-photo" />
    </div>
  )
}
